import { Transform, Type } from 'class-transformer';
import { IsInt, IsOptional, IsString, Max, MaxLength, Min } from 'class-validator';
import { DEADLINE_ASSIGNEE_ID_MAX_LENGTH, MAX_RENEWAL_VALIDITY_MONTHS } from './deadline.constants';
import { DEADLINE_UPLOAD_TOKEN_MAX_LENGTH } from './deadline-ai.constants';
import { IsIsoDay } from './is-iso-day.decorator';

export class RenewDeadlineDto {
  /**
   * Data del nuovo documento o dell'attività svolta (`YYYY-MM-DD`). Ricorrente: obbligatoria
   * (lo verifica il service); unica: facoltativa (solo storico) o, per i client vecchi, al posto di `dueAt`.
   */
  @IsOptional()
  @IsIsoDay()
  issuedAt?: string;

  /** Unica: nuova data di scadenza digitata (non nel passato, lo verifica il service). */
  @IsOptional()
  @IsIsoDay()
  dueAt?: string;

  /** Ricorrente: "da questo rinnovo vale N mesi". Unica: "da ora si rinnova ogni N mesi". */
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(MAX_RENEWAL_VALIDITY_MONTHS)
  validityMonths?: number;

  /** Persona del rinnovo. Assente = invariata; stringa vuota nel multipart = togli la persona. */
  @IsOptional()
  @Transform(({ value }) => (value === '' ? null : value))
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string | null;

  /** Al posto del file: il documento già caricato in anteprima. Con entrambi, 400. */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_UPLOAD_TOKEN_MAX_LENGTH)
  uploadToken?: string;
}
